module.exports = __webpack_public_path__ + "b7e7de4a36f102354e79152e90ec24c5.png";